<template>
    <div class="data-wrapper-core subuser-wrapper">
        <template v-if="!hideHeader">
            <h3>Subusers</h3>
            <v-divider></v-divider>
        </template>
        <v-text-field class="subuser-search-field" prepend-inner-icon="mdi-magnify" variant="outlined" density="compact" label="Suche" hide-details single-line
                rounded="lg" v-model="searchQuery"></v-text-field>
        <v-expansion-panels class="subuser-panels">
            <v-expansion-panel rounded="lg" v-for="subuser in filteredSubusers" :key="subuser._id">
                <v-expansion-panel-title class="subuser-panel-title">
                    <h4>{{ subuser.name }}</h4>
                </v-expansion-panel-title>
                <v-expansion-panel-text class="subuser-panel-text">
                    <v-list density="compact">
                        <h4>Email:</h4>
                        <v-list-item>{{ subuser.email || "--" }}</v-list-item>
                        <h4>Erstellt am:</h4>
                        <v-list-item>{{ subuser.createdAt || "--" }}</v-list-item>
                        <h4>Letzter Login:</h4>
                        <v-list-item>{{ subuser.lastSeen || "--" }}</v-list-item>
                        <h4>Roles:</h4>
                        <v-list-item v-for="role in subuser.roles" :key="role">
                            {{ role }}
                        </v-list-item>
                        <h4>Allowed Customers:</h4>
                        <v-list-item v-for="customer in subuser.allowedCustomers" :key="customer">
                            {{ customer }}
                        </v-list-item>
                    </v-list>
                </v-expansion-panel-text>
            </v-expansion-panel>
        </v-expansion-panels>
    </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
    props: {
        hideHeader: { type: Boolean, default: false }
    },
    data() {
        return {
            searchQuery: '',
        };
    },
    computed: {
        ...mapState('agency', ['subusers']),
        filteredSubusers() {
            if (!this.searchQuery) {
                return this.subusers;
            }
            return this.subusers.filter(subuser => subuser.name.toLowerCase().includes(this.searchQuery.toLowerCase()));
        },
    },

};
</script>

<style scoped>
.subuser-wrapper {
    max-height: 600px;
    overflow-y: auto;
}

.subuser-search-field {
    margin: 8px 0;
}

.subuser-panels {
    margin: 8px 0;
}

.subuser-panel-text {
    padding: 0px 16px;
}
</style>